/**
 * @generated SignedSource<<c16f65317e2190275aeabdefd996c6a0>>
 * @relayHash baeb10a0ac95074f3eae82d09a394c95
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 723d06c0106daee68edee747d9b7345e42cd7436a0584685ae9f9f5ad483d154

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery } from './uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "723d06c0106daee68edee747d9b7345e42cd7436a0584685ae9f9f5ad483d154",
    "metadata": {},
    "name": "uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
